import { Controller } from "@hotwired/stimulus";
import SimpleLightbox from "simplelightbox";

// Connects to data-controller="lightbox"
export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.initializeLightbox();
  }

  disconnect() {
    this.destroyLightbox();
  }

  linkTargetConnected() {
    this.initializeLightbox();
  }

  linkTargetDisconnected() {
    this.initializeLightbox();
  }

  initializeLightbox() {
    this.destroyLightbox();

    if (!this.hasLinkTarget) return;

    this.lightbox = new SimpleLightbox(this.linkTargets, {
      captionDelay: 150,
      captionsData: "title",
      captionPosition: "bottom",
      captionSelector: "self",
      fileExt: false,
      history: false,
      overlayOpacity: 0.99,
    });
  }

  destroyLightbox() {
    if (!this.lightbox) return;

    this.lightbox.destroy();
    this.lightbox = undefined;
  }
}
